import React from "react";
import { Avatar, Tooltip } from "antd";
import { UserOutlined } from "@ant-design/icons";

interface UserAvatarProps {
  handleUserSidebar: (value: boolean) => void;
}

const UserAvatar: React.FC<UserAvatarProps> = ({ handleUserSidebar }) => {
  const username = localStorage.getItem("username");
  const themeColor = JSON.parse(
    localStorage.getItem("color-theme") || '"#002F5F"'
  );

  const getInitialsFromUsername = (username?: string) => {
    if (!username) return null;

    return username
      .trim()
      .split(/\s+/)
      .map((word) => word.charAt(0).toUpperCase())
      .slice(0, 2)
      .join("");
  };

  const initials = getInitialsFromUsername(username || "");

  return (
    <Tooltip title={username}>
      <Avatar
        size={70}
        style={{
          backgroundColor: themeColor,
          color: "#fff",
          fontWeight: "bold",
          fontSize: "30px",
        }}
        onClick={() => handleUserSidebar(true)}
        icon={!username && <UserOutlined />}
        className="flex items-center justify-center hover:cursor-pointer absolute right-4"
      >
        {username ? initials : null}
      </Avatar>
    </Tooltip>
  );
};

export default UserAvatar;
